var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMemo } from 'react';
import { checkIsEnterprise } from '#services';
import { useWorkspaceById } from './useWorkspaceById';
export const useCheckIsEnterprise = (workspaceId) => {
    _react_refresh_temp_1();
    const { query: { data: workspaceData, isError: isErrorWorkspace, isPending: isPendingWorkspace, }, } = useWorkspaceById(workspaceId);
    const isEnterprise = useMemo(() => checkIsEnterprise(workspaceData?.billing), [workspaceData]);
    return {
        isEnterprise,
        isPending: isPendingWorkspace,
        isError: isErrorWorkspace,
    };
};
_react_refresh_temp_1(useCheckIsEnterprise, "Cc4E4n9PgAD+e3S2muyX1Figfjs=", false, () => [useWorkspaceById]);
